import React, { useState } from "react";
import styled from "styled-components";
const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
`;

const Weight = styled.div`
  font-size: 6em;
  font-weight: 700;
  letter-spacing: -0.02em;
  padding: 0.45em;
  display: flex;
`;
const Buttons = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 0.5em;
`;
const AdjustButton = styled.div`
  width: 40%;
  height: 92px;
  border-radius: 18px;
  background: linear-gradient(135deg, #1fe39a 0%, #0bbd7d 100%);
  color: #04231a;
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 2.4em;
  font-weight: 700;
  user-select: none;
  cursor: pointer;
  box-shadow: 0 8px 22px rgba(11, 189, 125, 0.28);
  transition: transform 0.08s ease, filter 0.15s ease;
  &:active {
    transform: translateY(2px);
    filter: brightness(1.06);
  }
`;
const MinusButton = styled(AdjustButton)`
  background: linear-gradient(135deg, #f0466b 0%, #d0163f 100%);
  color: #fff;
  box-shadow: 0 8px 22px rgba(208, 22, 63, 0.26);
`;
const FinishedButton = styled.div`
  width: 85%;
  height: 72px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.peg_background};
  color: ${({ theme }) => theme.colors.text};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.outline};
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 1.5em;
  font-weight: 600;
  margin-top: 1.5em;
  user-select: none;
  cursor: pointer;
`;

export default function CountDataEntry({
  initialTotalWeighIn,
  onSave,
  onDone,
}) {
  const [total, setTotal] = useState(initialTotalWeighIn);

  // Each press is saved straight away, so there is no Save step to forget.
  function adjust(by) {
    const next = Math.max(total + by, 0);
    setTotal(next);
    onSave(next);
  }

  return (
    <Main>
      <Weight>{total}</Weight>
      <Buttons>
        <MinusButton onClick={() => adjust(-1)}>-</MinusButton>
        <AdjustButton onClick={() => adjust(1)}>+</AdjustButton>
      </Buttons>
      <FinishedButton onClick={onDone}>Finished Session</FinishedButton>
    </Main>
  );
}
